import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import "../../styles/form.css";
import "../../styles/homeCustom.css";
import Animation from "../Animation";
import GeneralTeacherTemp from "./teachersTemps/GeneralTeacherTemp";

const Home = () => {
  const navigate = useNavigate();
  const { user, portal } = useAppSelector((state) => state.store);

  if (!portal)
    return (
      <div className="flex items-center justify-center h-screen">
        <span className="spinner"></span>
      </div>
    );

  if (user && portal) navigate("/");

  return (
    <Animation>
      <div className="home">
        <GeneralTeacherTemp />
      </div>
    </Animation>
  );
};

export default Home;
